import { FC, useState } from 'react';
import { CircularProgress, IconButton } from '@mui/material';
import { CloudDownload } from '@mui/icons-material';
import useTaxReportDownload from 'hooks/useTaxReportDownload';

type Props = {
  taxYearStart: number;
  investorId: string;
};

const DownloadTaxReportButton: FC<Props> = ({ taxYearStart, investorId }) => {
  const { downloadReport } = useTaxReportDownload();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await downloadReport(taxYearStart, investorId);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <IconButton onClick={handleDownload} disabled={isDownloading} size="small">
      {isDownloading ? (
        <CircularProgress size={20} />
      ) : (
        <CloudDownload color="primary" />
      )}
    </IconButton>
  );
};

export default DownloadTaxReportButton;
